import {baseRequestService} from "../base.ts";

export const eventsEventIdCancelPost = (eventId: string) => baseRequestService({
    url: `/events/${eventId}/cancel`,
    method: 'POST'
})